import React from 'react';

import {type RouteData} from '../types';
import {AUTOMATIONS_PATH} from './automationsPaths';

export const AUTOMATIONS_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // HomePageWithData handles tracking via HOME_NESTED_ROUTES
    },
    exact: true,
    isPrivateRoute: false,
    path: AUTOMATIONS_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
];
